export const captcha = {
  privacyPolicy: 'Privacy Policy',
  template: 'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
  termsOfService: 'Terms of Service'
};
